import { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { PopularSearches } from 'components/UI/PopularSearches/PopularSearches';
import { SearchForm } from 'components/SearchFormAndResults/SearchFormContainer/SearchForm/SearchForm';
import { SearchFormFilterLabels } from 'components/SearchFormAndResults/SearchFormContainer/SearchFormFilterLabels/SearchFormFilterLabels';
import { SearchFormFilterControls } from 'components/SearchFormAndResults/SearchFormContainer/SearchFormFilterControls/SearchFormFilterControls';
import { SearchContext } from 'components/SearchFormAndResults/SearchFormAndResultsProvider';
import './SearchFormContainer.scss';

export const SearchFormContainer = (props) => {
  const { popularSearches, searchOrderBy, searchSet, searchString } = props;
  const { setSearchFilters, setSortByFilter, setSearchString } =
    useContext(SearchContext);

  useEffect(() => {
    setSearchFilters(searchSet[0].searchResultFilterItems);
    setSortByFilter(1);
    setSearchString(searchString);
  }, []);

  return (
    <>
      <div
        className="search-form__container container"
        data-testid="search-form-container"
      >
        <h2 className="search-form__heading h3">Search results</h2>
        <SearchForm />
        <div className="search-form__popular-searches col-md-6 col-md-offset-2">
          <PopularSearches popularSearches={popularSearches} />
        </div>
        <SearchFormFilterControls searchOrderBy={searchOrderBy} />
      </div>
      <SearchFormFilterLabels />
    </>
  );
};

SearchFormContainer.propTypes = {
  popularSearches: PropTypes.arrayOf(PropTypes.object),
  searchOrderBy: PropTypes.arrayOf(PropTypes.object),
  searchSet: PropTypes.arrayOf(PropTypes.object),
  searchString: PropTypes.string,
};
